import { useNavigate } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewCostCenterModal from 'modules/finance/components/NewCostCenterModal'
import WithPaywall from 'modules/finance/components/WithPaywall'

const CreateCostCenterModalPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const onClose = () => {
    navigate(navigation.settings.finance.costCenters.list.fullPath())
  }

  return (
    <WithPaywall features={[Features.finance_cost_center_management]} fallback={<></>}>
      {() => <NewCostCenterModal onClose={onClose} />}
    </WithPaywall>
  )
}

export default CreateCostCenterModalPage
